export const request = async <T>(
    method: string,
    url: string,
    data?: {} | FormData,
): Promise<T | null> => {
    let queryString = '';
    const isFormData = data instanceof FormData;

    const getUrl = () => {
        if (method === 'GET' && data) {
            if (!isFormData) {
                queryString = '?' + new URLSearchParams(data).toString();
            } else {
                console.error(
                    'GET requests should have data as a plain object, FormData is not supported for GET.',
                );
            }
        }

        return url + queryString;
    };

    const getRequestBody = () => {
        if (method === 'GET') {
            return undefined;
        }

        if (isFormData) {
            return data;
        }

        return JSON.stringify(data);
    };

    const response = await fetch(getUrl(), {
        method,
        credentials: 'include',
        body: getRequestBody(),
        ...(!isFormData && {
            headers: {
                'Content-Type': 'application/json',
            },
        }),
    });

    if (response.status === 204) {
        return null;
    }

    const responseData = response.json && (await response.json());

    if (!response.ok) {
        if (
            response.status === 400 &&
            responseData?.message === 'Invalid request'
        ) {
            return responseData;
        }

        const error = new Error(`Error: ${response.status}`);
        (error as any).cause = responseData;
        throw error;
    }

    return responseData;
};
